import { toBlob } from "dom-to-image";

export const exportElementAsPng = (node, options = {}) =>
  toBlob(node, { bgcolor: "white", ...options });
